import React, { ReactElement } from "react";
import HiddenField from "./fields/HiddenField";
import { fieldId, fieldName, i18nKey } from "../../../utils/AttributeUtils";

interface Props {
  scope: string;
  columnName: string;
  value: string | number;
  relatedModelName?: string;
  index?: number;
}

export default function HiddenForm(props: Props): ReactElement {
  const { scope, relatedModelName, columnName, value, index } = props;
  return (
    <HiddenField
      id={fieldId(scope, relatedModelName, columnName, index)}
      name={fieldName(scope, relatedModelName, columnName, index)}
      value={value}
    />
  );
}
